/* eslint-disable react/require-default-props */
import React from 'react';
import './CrudHeader.scss';
function CrudHeader({ title, subtitle, children }) {
    return (React.createElement("div", { className: "crud-header position-relative" },
        React.createElement("h2", null,
            title,
            " ",
            subtitle && React.createElement("span", null, subtitle)),
        children));
}
export default CrudHeader;
